import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export interface TableSkeletonProps {
    columns?: number;
    rows?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns = 5, rows = 10 }) => {
    const theme = useTheme();
    const colIndices = Array.from({ length: columns }, (_, i) => i);
    const rowIndices = Array.from({ length: rows }, (_, i) => i);

    const headerBg =
        theme.palette.mode === 'dark'
            ? alpha(theme.palette.grey[700], 0.55)
            : alpha(theme.palette.grey[300], 0.6);
    const headerBorder = alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.9 : 1);
    const rowBorder = alpha(theme.palette.divider, 0.6);
    const headerSkeletonBg = alpha(
        theme.palette.common.white,
        theme.palette.mode === 'dark' ? 0.12 : 0.35,
    );

    return (
        <Box sx={{ borderRadius: 2, overflow: 'hidden', bgcolor: 'action.hover' }}>
            <table
                style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    tableLayout: 'fixed',
                }}
            >
                <thead>
                    <tr>
                        {colIndices.map((c) => (
                            <th
                                key={c}
                                style={{
                                    padding: '10px 12px',
                                    textAlign: 'left',
                                    backgroundColor: headerBg,
                                    borderBottom: `1px solid ${headerBorder}`,
                                }}
                            >
                                <Skeleton
                                    animation="wave"
                                    variant="rounded"
                                    height={18}
                                    sx={{ bgcolor: headerSkeletonBg }}
                                />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rowIndices.map((r) => (
                        <tr key={r}>
                            {colIndices.map((c) => (
                                <td
                                    key={c}
                                    style={{
                                        padding: '10px 12px',
                                        borderBottom: `1px solid ${rowBorder}`,
                                    }}
                                >
                                    <Skeleton
                                        animation="wave"
                                        variant="rounded"
                                        height={16}
                                        width={`${55 + ((c + r * 3) % 5) * 8}%`}
                                        sx={{ maxWidth: '100%' }}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
    );
};

export default TableSkeleton;
